import Checkbox from "@/ui-lib/components/Checkbox";
import { Option } from "@/utils/groupOptionsByPreferences";
import { useTheme } from "@emotion/react";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import Flex from "@ternary/api-lib/ui-lib/components/Flex";
import Icon from "@ternary/api-lib/ui-lib/components/Icon";
import { Tooltip } from "@ternary/api-lib/ui-lib/components/Tooltip";
import Text from "@ternary/web-ui-lib/components/Text";
import React from "react";
import { OptionProps, components } from "react-select";
import { DataIntegrationIcon } from "./DataIntegrationIcon";
import copyText from "./ProviderLineageOption.copyText";

export const ProviderLineageOption = (
  props: OptionProps<Option, boolean>
): React.JSX.Element => {
  const theme = useTheme();
  const providerName = (
    props.data as Option & {
      providerName: string;
    }
  ).providerName;

  const helpText = copyText[`optionTooltipText${props.data.label}`];

  return (
    <components.Option {...props}>
      <Flex alignItems="center" justifyContent="space-between" width="100%">
        <Flex alignItems="center" gap={theme.space_xs} width="100%">
          {props.isMulti && (
            <>
              <Checkbox checked={props.isSelected} />
            </>
          )}
          <DataIntegrationIcon size={16} providerType={providerName} />
          <Text truncate title={props.data.label}>
            {props.data.label}
          </Text>
        </Flex>
        {helpText && (
          <Tooltip content={helpText}>
            <Icon
              icon={faInfoCircle}
              size="sm"
              color={theme.text_color_secondary}
            />
          </Tooltip>
        )}
      </Flex>
    </components.Option>
  );
};
